import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type AddBasketProductResponse = {
  __typename?: 'AddBasketProductResponse';
  basket: Basket;
  basketProducts: Array<BasketProduct>;
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

export type AddProductPrerequisite = {
  __typename?: 'AddProductPrerequisite';
  /** Prerequisite description */
  message: Scalars['String']['output'];
  /** Prerequisite unique identifier */
  value: AddProductPrerequisiteEnum;
};

export enum AddProductPrerequisiteEnum {
  /** BankID or Diia.Pidpys verification required to add product */
  BankIdVerification = 'BANK_ID_VERIFICATION',
  /** User have to refill balance to add product */
  CriticalBalance = 'CRITICAL_BALANCE',
  /** Phone verification required to add product */
  PhoneVerification = 'PHONE_VERIFICATION',
  /** Mark all deals required to add product */
  PotentialDealsDeactivation = 'POTENTIAL_DEALS_DEACTIVATION',
  /** Connected social account required to add product */
  SocialAccount = 'SOCIAL_ACCOUNT'
}

export type AnswerDataGraph = {
  questionId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum AuthService {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type Basket = {
  __typename?: 'Basket';
  groups: Array<BasketGroup>;
  productsCount: Scalars['Int']['output'];
};

export type BasketGroup = {
  __typename?: 'BasketGroup';
  basketProducts: Array<BasketProduct>;
  info: BasketGroupInfo;
  seller?: Maybe<User>;
};

export type BasketGroupInfo = {
  __typename?: 'BasketGroupInfo';
  totalPrice: Scalars['String']['output'];
};

export type BasketOrderCreateInput = {
  allLabels?: InputMaybe<Array<UtmLabels>>;
  /** `id` of the city where you want to get order. */
  cityId: Scalars['String']['input'];
  /** `name` of the city where you want to get order. */
  cityName: Scalars['String']['input'];
  /** In this field you need specify delivery kind which you have chosen. */
  deliveryService: DeliveryService;
  /** Buyer email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Buyer first name. */
  firstName: Scalars['String']['input'];
  /** Utm Labels */
  labels?: InputMaybe<UtmLabels>;
  /** Buyer last name. */
  lastName: Scalars['String']['input'];
  /** Buyer patronymic. */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Type of the payment methos that is chosen by buyer */
  paymentType?: InputMaybe<PaymentMethodEnum>;
  /** Buyer phone number. */
  phoneNumber: Scalars['String']['input'];
  /** `true` if need to send sms for phone verification */
  phoneVerificationRequired: Scalars['Boolean']['input'];
  /** `id` of the region where you want to get order. */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** `name` of the region where you want to get order. */
  regionName?: InputMaybe<Scalars['String']['input']>;
  smartPlanId?: InputMaybe<Scalars['String']['input']>;
  /**
   * `id` of warehouse where you want to get
   * order.
   */
  warehouseId: Scalars['String']['input'];
  /**
   * `name` of the warehouse where you want to get
   * order.
   */
  warehouseName: Scalars['String']['input'];
  warehouseType?: InputMaybe<WarehouseType>;
};

export type BasketProduct = {
  __typename?: 'BasketProduct';
  /** Product count */
  count: Scalars['Int']['output'];
  /** Id of basket product for update\delete */
  id: Scalars['Int']['output'];
  oldPrice?: Maybe<Scalars['String']['output']>;
  /** product price * count */
  price: Scalars['String']['output'];
  /** Product itself */
  product?: Maybe<Product>;
  /** Basket product id */
  productId: Scalars['Int']['output'];
  productOldPrice?: Maybe<Scalars['String']['output']>;
  /** product price depend on size */
  productPrice: Scalars['String']['output'];
  /** Selected size */
  size?: Maybe<Size>;
  /** Basket size id */
  sizeId: Scalars['Int']['output'];
};

/** Type represents products brands info */
export type Brand = {
  __typename?: 'Brand';
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isUkrainian?: Maybe<Scalars['Boolean']['output']>;
  isViewerSubscribed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export enum ButtonEnum {
  /** Success, let user navigate to his orders */
  MyOrders = 'MY_ORDERS',
  /**
   * Success, but no need to go to orders
   * (for example in service payments)
   */
  Succeed = 'SUCCEED',
  SucceedNextOrder = 'SUCCEED_NEXT_ORDER',
  /** Purchase wasn't successful, ask user to try again */
  TryAgain = 'TRY_AGAIN'
}

export enum CardConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CargoDeliveryRestriction = {
  __typename?: 'CargoDeliveryRestriction';
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** This type represent information about the catalog */
export type Catalog = {
  __typename?: 'Catalog';
  /** The `id` of current catalog. */
  id: Scalars['Int']['output'];
  isProductsReturnable: Scalars['Boolean']['output'];
  /** The `slug` of current catalog. */
  slug: Scalars['String']['output'];
  /** The `title` of current catalog. */
  title: Scalars['String']['output'];
};

export type Characteristic = {
  __typename?: 'Characteristic';
  choices?: Maybe<Array<ProductCharacteristicChoice>>;
  id: Scalars['Int']['output'];
  maxCountForSelect: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type City = {
  __typename?: 'City';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Color = {
  __typename?: 'Color';
  enum: ColorEnum;
  hex: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum ColorEnum {
  Beige = 'BEIGE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Burgundy = 'BURGUNDY',
  Coral = 'CORAL',
  Cyan = 'CYAN',
  Golden = 'GOLDEN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Khaki = 'KHAKI',
  LightGreen = 'LIGHT_GREEN',
  Lilac = 'LILAC',
  Multicolor = 'MULTICOLOR',
  Mustard = 'MUSTARD',
  Orange = 'ORANGE',
  Peach = 'PEACH',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Silver = 'SILVER',
  Turquoise = 'TURQUOISE',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type Condition = {
  __typename?: 'Condition';
  enum: ConditionEnum;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum ConditionEnum {
  Alright = 'ALRIGHT',
  Good = 'GOOD',
  Ideal = 'IDEAL',
  New = 'NEW',
  VeryGood = 'VERY_GOOD'
}

export type CreateOrderFromBasketResponse = {
  __typename?: 'CreateOrderFromBasketResponse';
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
  order?: Maybe<Order>;
};

export type CreateProductReviewMutation = {
  __typename?: 'CreateProductReviewMutation';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type CreateUserReviewMutation = {
  __typename?: 'CreateUserReviewMutation';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

/** Places where order can be declined */
export enum DeclinePlace {
  Chat = 'CHAT'
}

export type DeclineReasonArgument = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: OrderDeclineReason;
};

export type DeleteBasketProductResponse = {
  __typename?: 'DeleteBasketProductResponse';
  basket: Basket;
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

/** This type represent information about devilery method. */
export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  /** Default price for the delivery method */
  defaultPrice?: Maybe<Scalars['Int']['output']>;
  /** Value of enum for current delivery method */
  deliveryService: DeliveryService;
  /** Delivery description */
  description: Scalars['String']['output'];
  /** Icon for the delivery method */
  icon: Scalars['String']['output'];
  /** Human readeble representation */
  name: Scalars['String']['output'];
  /** Description of delivery in smart subscription */
  smartDescription?: Maybe<Scalars['String']['output']>;
  /** Description of postomate delivery in smart subscription */
  smartPostomateDescription?: Maybe<Scalars['String']['output']>;
};

/** Possible delivery services. */
export enum DeliveryService {
  Justin = 'JUSTIN',
  Meest = 'MEEST',
  NovaPoshta = 'NOVA_POSHTA',
  Rozetka = 'ROZETKA',
  UkrPoshta = 'UKR_POSHTA'
}

export type DeliverySettingsWarehouse = {
  __typename?: 'DeliverySettingsWarehouse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<WarehouseType>;
};

export type DeliveryStatusForTracking = {
  __typename?: 'DeliveryStatusForTracking';
  deliveryStatus?: Maybe<Scalars['String']['output']>;
};

export type Dialog = {
  __typename?: 'Dialog';
  actions: Array<DialogAction>;
  analyticCommission?: Maybe<Scalars['String']['output']>;
  commissionPercent: Scalars['String']['output'];
  /** Dialog id */
  id: Scalars['Int']['output'];
  previewImages?: Maybe<Array<Scalars['String']['output']>>;
  reviewsRequest?: Maybe<ReviewRequest>;
  /** Thread id. threadId != id */
  threadId: Scalars['Int']['output'];
  totalCommission?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['String']['output']>;
};

export enum DialogAction {
  Approve = 'APPROVE',
  Buy = 'BUY',
  DisabledApprove = 'DISABLED_APPROVE',
  LeaveRating = 'LEAVE_RATING',
  LeaveReview = 'LEAVE_REVIEW',
  MarkAsSold = 'MARK_AS_SOLD',
  OrderDetail = 'ORDER_DETAIL',
  OrderMarkAsSold = 'ORDER_MARK_AS_SOLD',
  Pay = 'PAY',
  ProductDetails = 'PRODUCT_DETAILS'
}

export type EditNotificationSettingsMutation = {
  __typename?: 'EditNotificationSettingsMutation';
  errors?: Maybe<Array<MutationFieldErrors>>;
  user?: Maybe<User>;
};

export type EvoCardsInfo = {
  __typename?: 'EvoCardsInfo';
  /** Image of the bank if can be acquired */
  bankImage?: Maybe<Scalars['String']['output']>;
  /**
   * Card holder id, this is used for most operations
   * @deprecated use id
   */
  cardHolderId: Scalars['String']['output'];
  /** Mask of the card *** 1430 */
  cardMask: Scalars['String']['output'];
  /** Date of expiration for card */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Card id */
  id?: Maybe<Scalars['String']['output']>;
  /** Is the currect card selected as a default */
  isDefault: Scalars['Boolean']['output'];
  /** Whether card expired */
  isExpired: Scalars['Boolean']['output'];
  /** `true` if card added in another project (prom, izi, crafta, ...) */
  isExternal: Scalars['Boolean']['output'];
  /** Type of the card Visa/Mastercard */
  type?: Maybe<Scalars['String']['output']>;
};

export type ExternalPaymentCardsInfo = {
  __typename?: 'ExternalPaymentCardsInfo';
  cardsCount: Scalars['Int']['output'];
  /** IZI.ua, Prom.ua, ... */
  projectDomainNameVerbose?: Maybe<Scalars['String']['output']>;
  projectIconUrl?: Maybe<Scalars['String']['output']>;
  /** 'shafa', 'crafta', ... */
  projectId: Scalars['String']['output'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  /** SHAF_17897 */
  abTestRestartRankingFormula2: Scalars['Boolean']['output'];
  /** SHAF_9161 */
  bankIdEnabled: Scalars['Boolean']['output'];
  /** SHAF-6619 */
  basketEnabled: Scalars['Boolean']['output'];
  /** Buyer commission flag */
  buyerCommissionEnabled: Scalars['Boolean']['output'];
  /** SHAF_17610 */
  checkQuantityForNewState: Scalars['Boolean']['output'];
  enableDiscountPagePersonalized: Scalars['Boolean']['output'];
  /** Evopay is enabled for refill balance \ promotion payments */
  evoPayServicePaymentEnabled: Scalars['Boolean']['output'];
  justinActionEnabled: Scalars['Boolean']['output'];
  /** SHAF-3036 */
  justinSpecialPromoEnabled: Scalars['Boolean']['output'];
  marathonActionEnabled: Scalars['Boolean']['output'];
  meestExpressPromoEnabled: Scalars['Boolean']['output'];
  /** SHAF-8206 */
  mobileSimilarProductsPopup: Scalars['Boolean']['output'];
  /** SHAF-4135 - is multiple price change in "my store" enabled */
  multiplePriceChangeEnabled: Scalars['Boolean']['output'];
  /** SHAF_7172 */
  newReviews: Scalars['Boolean']['output'];
  /** SHAF_8870 */
  notifications: Scalars['Boolean']['output'];
  /** SHAF_12424 */
  payLaterEnabled: Scalars['Boolean']['output'];
  /** SHAF-3207 */
  pbrBannersEnabled: Scalars['Boolean']['output'];
  /** Enable PBR ui */
  pbrUiEnabled: Scalars['Boolean']['output'];
  /** SHAF-5505 - if enabled, then use big write message button */
  productBigWriteButtonEnabled: Scalars['Boolean']['output'];
  /** SHAF_19108 */
  profileSocialPostsEnabled: Scalars['Boolean']['output'];
  /** SHAF_12484 */
  promotionPackagesEnabled: Scalars['Boolean']['output'];
  /** SHAF-3502 - is school sale enabled? */
  schoolSaleEnabled: Scalars['Boolean']['output'];
  /** SHAF_12164 */
  smartEnabled: Scalars['Boolean']['output'];
  /** SHAF-17683 */
  smartOneClick: Scalars['Boolean']['output'];
  /** SHAF_6466_SPLIT_REFUND */
  splitRefundEnabled: Scalars['Boolean']['output'];
  staticABTestFlag: Scalars['Boolean']['output'];
  /** SHAF-3144 */
  summerSaleEnabled: Scalars['Boolean']['output'];
  /** SHAF-4687 */
  systemMessageEnabled: Scalars['Boolean']['output'];
  /** SHAF_8817 */
  uaRuFields: Scalars['Boolean']['output'];
};

export type Fingerprint = {
  browserAcceptHeader: Scalars['String']['input'];
  browserColorDepth: Scalars['String']['input'];
  browserJavaEnabled: Scalars['String']['input'];
  browserLanguage: Scalars['String']['input'];
  browserScreenHeight: Scalars['String']['input'];
  browserScreenWidth: Scalars['String']['input'];
  browserTimeZone: Scalars['String']['input'];
  browserTimeZoneOffset: Scalars['String']['input'];
  browserUserAgent: Scalars['String']['input'];
};

export type FreeShippingInfoType = {
  __typename?: 'FreeShippingInfoType';
  /** End date of the free shipping */
  endDate: Scalars['DateTime']['output'];
  /** Free delivery landing id */
  landingSlug: Scalars['String']['output'];
};

export type GlobalSettings = {
  __typename?: 'GlobalSettings';
  featureFlags: FeatureFlags;
};

export type LocationInfoInput = {
  /** The `id` of the current location type. */
  id: Scalars['String']['input'];
  /** The `Name` of the current location type. */
  name: Scalars['String']['input'];
};

export type LogoImage = {
  __typename?: 'LogoImage';
  /** Image of Android logo. */
  imageAndroid: Scalars['String']['output'];
  /** Image of IOS logo. */
  imageIos: Scalars['String']['output'];
  /** Image of of web logo. */
  imageWeb: Scalars['String']['output'];
  /** Logo is active */
  isActive: Scalars['Boolean']['output'];
  /** Title of logo. */
  title: Scalars['String']['output'];
};

export type MainBanner = {
  __typename?: 'MainBanner';
  slides: Array<MainBannerSlide>;
};

export type MainBannerSlide = {
  __typename?: 'MainBannerSlide';
  id: Scalars['Int']['output'];
  /** Image for slide on main banner */
  image: SlideImage;
  /** Image for banner on a product page */
  productDetailsImage: SlideImage;
  /** Slide title, can be used as description for image if last one can't be loaded */
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarkNotificationsAsReadMutation = {
  __typename?: 'MarkNotificationsAsReadMutation';
  notification: Notification;
};

export type MarkSavedSearchAsViewedResponse = {
  __typename?: 'MarkSavedSearchAsViewedResponse';
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

export type MiniLanding = {
  __typename?: 'MiniLanding';
  /** Title of button with url in mini-landing */
  buttonTitle: Scalars['String']['output'];
  /** Url for button in mini-landing */
  forwardUrl: Scalars['String']['output'];
  /** Url of image for mini-landing */
  imageUrl: Scalars['String']['output'];
  /** HTML content for mini-landing */
  markup: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBasketProduct: AddBasketProductResponse;
  /**
   * Create order.
   * ### error_codes(field 'firstName'):
   * * __long_string__ - String is longer than 100 characters
   * * __required__ - is required
   * ### error_codes(field 'lastName'):
   * * __long_string__ - String is longer than 100 characters
   * * __required__ - is required
   * ### error_codes(field 'phoneNumber'):
   * * __does_not_match_re__ - does not match pattern
   * * __required__ - is required
   * ### error_codes(field 'email'):
   * * __is_not_a_string__ - value is not a string
   * * __long_string__ - String is longer than 100 characters
   * ### error_codes(field 'productId'):
   * * __is_not_int__ - value is not int
   * * __too_small__ - value should be greater than 0
   * * __required__ - is required
   * ### error_codes(field 'deliveryService'):
   * * __invalid__ - wrong delivery service
   * * __required__ - is required
   * ### error_codes(field 'warehouseId'):
   * * __is_not_a_string__ - value is not a string
   * * __long_string__ - String is longer than 100 characters
   * * __required__ - is required
   * ### error_codes(field 'warehouseName'):
   * * __is_not_a_string__ - value is not a string
   * * __required__ - is required
   * ### error_codes(field 'cityName'):
   * * __is_not_a_string__ - value is not a string
   * * __required__ - is required
   * ### error_codes(field 'cityId'):
   * * __required__ - is required
   * ### error_codes(field 'regionName'):
   * * __is_not_a_string__ - value is not a string
   * ### error_codes(field '__all__'):
   * * __payment_method_unavailable__ - Payment method unavailable
   * * __send_message_product_does_not_exist__ - Product hidden or not verified or visibility not in [visible reserve]
   * ### error_codes(field '{product_id}'): field is product_id
   * * __product_can_not_be_ordered__ - Product can not be ordered
   */
  createOrderFromBasket: CreateOrderFromBasketResponse;
  createProductReview?: Maybe<CreateProductReviewMutation>;
  /**
   * Create user review
   * ### error_codes(field '${questionId}'):
   * * __required__ - is required
   */
  createUserReview?: Maybe<CreateUserReviewMutation>;
  /** Remove basket item. If id is not provided, the mutation will clear the all basket */
  deleteBasketProduct: DeleteBasketProductResponse;
  editNotificationSettings: EditNotificationSettingsMutation;
  markNotificationAsRead?: Maybe<MarkNotificationsAsReadMutation>;
  markSavedSearchAsViewed: MarkSavedSearchAsViewedResponse;
  /**
   * Create dialog or append message to existing dialog from  authorized user to participant
   * ### error_codes(field 'body'):
   * * __max_length__ - Body length more than 2048 characters
   */
  messageSendToProductDialog?: Maybe<MessageSendToProductDialogResponse>;
  /**
   * novaPoshtaConfirmRegistration errors
   * ### error_codes(field '\__all\__'):
   * * __unknown_np_error__ - unknown nova poshata error
   * * __invalid_np_data__ - validation error
   * * __wrong_sms_code__ - wrong sms code
   * * __sms_attempts_exceeded__ - sms attempts exceeded
   */
  novaPoshtaConfirmRegistration: MutationResponse;
  /**
   * novaPoshtaRegistration errors
   * ### error_codes(field '\__all\__'):
   * * __unknown_np_error__ - unknown nova poshata error
   * * __invalid_np_data__ - validation error
   * * __sms_attempts_exceeded__ - sms attempts exceeded
   */
  novaPoshtaRegistration: MutationResponse;
  /**
   * ### error_codes(field '__all__'):
   * * __cant_be_declined__ - Order can't be declined, most likely because it's `SAFE_PAYMENT`
   */
  orderBuyerDecline: OrderActionsResponse;
  orderBuyerDelete: OrderActionsResponse;
  /**
   * Errors:
   * - subscription_required - if user create order with
   * subscription but subscription is not paid. `payload` field is subscription plan id
   */
  orderPurchaseWithCardId: PurchaseResponse;
  orderPurchaseWithToken: PurchaseResponse;
  /**
   * Mutation for approve order by seller
   * ### error_codes(field '\__all\__'):
   * * __unknown_np_error__ - unknown nova poshata error
   * * __invalid_np_data__ - validation error
   * * __must_nova_poshta_authenticate__ - user must registrate
   * * __incorrect_full_name__ - user give incorrect full name
   *                             (error message include correct full name)
   * *__cant_be_approved__ - The order can not be approved,
   * because it's probably`SAFE_PAYMENT` and not paid
   */
  orderSellerApprove: OrderActionsResponse;
  /**
   * ### error_codes(field '__all__'):
   * * __cant_be_declined__ - Order can't be declined, most likely because it's `SAFE_PAYMENT`
   */
  orderSellerDecline: OrderActionsResponse;
  orderSellerDelete: OrderActionsResponse;
  orderSellerSell: OrderActionsResponse;
  /**
   * Create service payment for product promotion using evopay card id
   * (product will be promoted after service payment will succeed)
   */
  promoteProductWithCardId: ServicePaymentResponse;
  /**
   * Create service payment for product promo package using evopay card id
   * (product will be promoted after service payment will succeed)
   */
  promoteProductWithPackageWithCardId: ServicePaymentResponse;
  /**
   * Create service payment for product promo package using evopay card token
   * (product will be promoted after service payment will succeed)
   */
  promoteProductWithPackageWithToken: ServicePaymentResponse;
  /**
   * Create service payment for product promotion using evopay card token
   * (product will be promoted after service payment will succeed)
   */
  promoteProductWithToken: ServicePaymentResponse;
  /**
   * Create service payment for balance refill using evopay card id
   * (balance will be refilled after service payment will succeed)
   */
  refillBalanceWithCardId: ServicePaymentResponse;
  /**
   * Create service payment for balance refill using evopay token
   * (balance will be refilled after service payment will succeed)
   */
  refillBalanceWithToken: ServicePaymentResponse;
  removeSavedSearch: RemoveSavedSearchResponse;
  saveDeviceInfo: SaveDeviceInfo;
  saveSearch: SaveSearchResponse;
  sendExternalCardsVerificationOTP: SendExternalCardsVerificationOtpResponse;
  setSavedSearchNewProductsNotify: SetSavedSearchNewProductsNotifyResponse;
  /**
   * ### error_codes(field '\__all\__'):
   * * __BRAND_SUBSCRIPTIONS_LIMIT_REACHED__ - maximum amount of subscribed brands reached
   */
  subscribeToBrand: SubscribeToBrandResponse;
  /**
   * ### error_codes(field '\__all\__'):
   * * __BRAND_SUBSCRIPTIONS_LIMIT_REACHED__ - maximum amount of subscribed brands reached
   */
  subscribeToBrands: SubscribeToBrandsResponse;
  /**
   * ### error_codes(field '\_\_all\_\_'):
   * * __ALREADY_SUBSCRIBED_TO_PRODUCT__ - this email already subscribed to this product
   * ### error_codes(field 'email'):
   * * __INVALID__ - invalid email format
   */
  subscribeToProduct: SubscribeToProductResponse;
  unsubscribeFromBrand: UnsubscribeFromBrandResponse;
  updateBasketProductCount: UpdateBasketProductCountResponse;
  /**
   * Update user payment methods
   * ### error_codes(field '__all__'):
   * * __disable_all_payments__ - All payment methods are disabled
   */
  updatePaymentMethods?: Maybe<UpdatePaymentMethodsResponse>;
  userAddEvoCardLookup?: Maybe<UserAddEvoCardLookupResponse>;
  /**
   * userAssociateWithSocialAccount errors
   * ### error_codes(field '\__all\__'):
   * * __account_already_associated__ - account already associated with user on shafa
   * * __auth_social_service_not_responding__ - social network not responding
   * ### error_codes(field 'accessToken'):
   * * __invalid_social_token__ - invalid access token
   */
  userAssociateWithSocialAccount?: Maybe<UserAssociateWithSocialAccountResponse>;
  /** Update settings for delivery services */
  userDeliverySettingUpdate?: Maybe<DeliverySettingUpdateResponse>;
  /**
   * Mutation for registration by phone without username
   * ### error_codes(field 'phone_number'):
   * * __invalid__ - Bad phone format
   * * __already_used__ - Phone already used by another user
   * ### error_codes(field 'first_name'):
   * * __max_length__ - first name length more than 50 characters
   */
  userFastRegistration?: Maybe<UserFastRegistrationResponse>;
  userMarkEvoCardAsDefault?: Maybe<UserMarkDefaultEvoCardResponse>;
  /**
   * Mutation for phone verification and saving a phone
   * ### error_codes(field 'verification_code'):
   * * __min_value__ - Verification code must contain 5 characters
   * * __max_value__ - Verification code must contain 5 characters
   * * __invalid__ - Enter a whole number
   * ### error_codes(field '\__all\__'):
   * * __sms_does_not_sent__ - Need resend sms. User data expired or doesn't exist.
   * * __code_invalid__ - Sent and Provided codes don't match
   */
  userPhoneVerification?: Maybe<MutationResponse>;
  userRemoveEvoCard?: Maybe<UserRemoveEvoCardResponse>;
  /**
   * userUpdateEmail errors
   * ### error_codes(field 'email'):
   * * __invalid__ - Bad email format
   * * __required__ - Email field is required
   * * __email_already_exist__ - Email already exist in db
   * * __email_provider_is_blocked__ - Email provider is blocked(mail.ru, yandex.ua ...)
   */
  userUpdateEmail: UserUpdateEmailResponse;
  userUpdateReturnPolicySetting?: Maybe<UserUpdateReturnPolicySetting>;
  userUpdateShopName?: Maybe<UserUpdateShopNameResponse>;
  verifyExternalCardsOTP: VerifyExternalCardsOtpResponse;
};


export type MutationAddBasketProductArgs = {
  productId: Scalars['Int']['input'];
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationCreateOrderFromBasketArgs = {
  params: BasketOrderCreateInput;
  sellerId: Scalars['Int']['input'];
};


export type MutationCreateProductReviewArgs = {
  data: Array<AnswerDataGraph>;
  productId: Scalars['Int']['input'];
  reviewRequestId: Scalars['Int']['input'];
};


export type MutationCreateUserReviewArgs = {
  data: Array<AnswerDataGraph>;
  reviewRequestId: Scalars['Int']['input'];
};


export type MutationDeleteBasketProductArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEditNotificationSettingsArgs = {
  settings: Array<NotificationSettingsUpdateInput>;
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationMarkSavedSearchAsViewedArgs = {
  lastViewedProductId: Scalars['Int']['input'];
  savedSearchId: Scalars['Int']['input'];
};


export type MutationMessageSendToProductDialogArgs = {
  body: Scalars['String']['input'];
  participantId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationNovaPoshtaConfirmRegistrationArgs = {
  code: Scalars['String']['input'];
};


export type MutationNovaPoshtaRegistrationArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationOrderBuyerDeclineArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationOrderBuyerDeleteArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationOrderPurchaseWithCardIdArgs = {
  cardId: Scalars['String']['input'];
  fingerprint?: InputMaybe<Fingerprint>;
  orderId: Scalars['Int']['input'];
};


export type MutationOrderPurchaseWithTokenArgs = {
  fingerprint?: InputMaybe<Fingerprint>;
  orderId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type MutationOrderSellerApproveArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationOrderSellerDeclineArgs = {
  declinePlace?: InputMaybe<DeclinePlace>;
  declineReason?: InputMaybe<DeclineReasonArgument>;
  orderId: Scalars['Int']['input'];
};


export type MutationOrderSellerDeleteArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationOrderSellerSellArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationPromoteProductWithCardIdArgs = {
  cardId: Scalars['String']['input'];
  fingerprint?: InputMaybe<Fingerprint>;
  productId: Scalars['Int']['input'];
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  tariffId: Scalars['Int']['input'];
};


export type MutationPromoteProductWithPackageWithCardIdArgs = {
  cardId: Scalars['String']['input'];
  fingerprint?: InputMaybe<Fingerprint>;
  packageId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  resultUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPromoteProductWithPackageWithTokenArgs = {
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Fingerprint>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPromoteProductWithTokenArgs = {
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Fingerprint>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  tariffId: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefillBalanceWithCardIdArgs = {
  amount: Scalars['Float']['input'];
  cardId: Scalars['String']['input'];
  fingerprint?: InputMaybe<Fingerprint>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefillBalanceWithTokenArgs = {
  amount: Scalars['Float']['input'];
  fingerprint?: InputMaybe<Fingerprint>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRemoveSavedSearchArgs = {
  savedSearchId: Scalars['Int']['input'];
};


export type MutationSaveDeviceInfoArgs = {
  deviceInfo: Scalars['String']['input'];
};


export type MutationSaveSearchArgs = {
  brands?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogSlug: Scalars['String']['input'];
  characteristics?: InputMaybe<Array<Scalars['Int']['input']>>;
  cities?: InputMaybe<Array<Scalars['Int']['input']>>;
  colors?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditions?: InputMaybe<Array<Scalars['Int']['input']>>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<Scalars['Int']['input']>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendExternalCardsVerificationOtpArgs = {
  projectId: Scalars['String']['input'];
  resendSms?: Scalars['Boolean']['input'];
};


export type MutationSetSavedSearchNewProductsNotifyArgs = {
  isNewProductsNotifyEnabled: Scalars['Boolean']['input'];
  savedSearchId: Scalars['Int']['input'];
};


export type MutationSubscribeToBrandArgs = {
  brandId: Scalars['Int']['input'];
};


export type MutationSubscribeToBrandsArgs = {
  brandsIds: Array<Scalars['Int']['input']>;
};


export type MutationSubscribeToProductArgs = {
  email: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationUnsubscribeFromBrandArgs = {
  brandId: Scalars['Int']['input'];
};


export type MutationUpdateBasketProductCountArgs = {
  id: Scalars['Int']['input'];
  newCount: Scalars['Int']['input'];
};


export type MutationUpdatePaymentMethodsArgs = {
  paymentMethod: PaymentMethodEnum;
  prepayment?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationUserAddEvoCardLookupArgs = {
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUserAssociateWithSocialAccountArgs = {
  accessToken: Scalars['String']['input'];
  service: AuthService;
};


export type MutationUserDeliverySettingUpdateArgs = {
  city?: InputMaybe<LocationInfoInput>;
  deliveryService: DeliveryService;
  isEnabled: Scalars['Boolean']['input'];
  region?: InputMaybe<LocationInfoInput>;
  warehouse?: InputMaybe<LocationInfoInput>;
};


export type MutationUserFastRegistrationArgs = {
  firstName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationUserMarkEvoCardAsDefaultArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserPhoneVerificationArgs = {
  userToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationUserRemoveEvoCardArgs = {
  cardHolderId?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserUpdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUserUpdateReturnPolicySettingArgs = {
  isEnabled: Scalars['Boolean']['input'];
  returnPolicy: ReturnPolicy;
};


export type MutationUserUpdateShopNameArgs = {
  shopName: Scalars['String']['input'];
};


export type MutationVerifyExternalCardsOtpArgs = {
  code: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type MutationError = {
  __typename?: 'MutationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MutationFieldErrors = {
  __typename?: 'MutationFieldErrors';
  field: Scalars['String']['output'];
  messages: Array<MutationError>;
  payload?: Maybe<Scalars['String']['output']>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type NextSteps = {
  __typename?: 'NextSteps';
  /** Full url to icon */
  icon: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /**
   * Next steps description
   * (String may contain `\n` characters)
   */
  text: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  button: NotificationButton;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationButton = {
  __typename?: 'NotificationButton';
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<Maybe<NotificationEdge>>;
  pageInfo: PageInfo;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Notification>;
};

export enum NotificationPriority {
  HighPriority = 'HIGH_PRIORITY',
  LowPriority = 'LOW_PRIORITY'
}

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: NotificationPriority;
};

export type NotificationSettingsUpdateInput = {
  id: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

/** This type represent data wich connected with order. */
export type Order = {
  __typename?: 'Order';
  accrualAmount?: Maybe<Scalars['String']['output']>;
  additionalCharge?: Maybe<Scalars['String']['output']>;
  appPayAllowed: Scalars['Boolean']['output'];
  /** The user who made order. */
  buyer?: Maybe<User>;
  /** The id of user who made order. */
  buyerId: Scalars['Int']['output'];
  /** Is user allowed to approve the order */
  canBeApprove: Scalars['Boolean']['output'];
  /** Is user allowed to decline the order */
  canBeDecline: Scalars['Boolean']['output'];
  /** Is user allowed to delete the order */
  canBeDelete: Scalars['Boolean']['output'];
  /** Is user allowed to mark current order as sold */
  canBeMarkAsSold: Scalars['Boolean']['output'];
  /** Can current user pay for this order */
  canBePaid?: Maybe<Scalars['Boolean']['output']>;
  /** Can the user return this product */
  canBeReturned?: Maybe<Scalars['Boolean']['output']>;
  /** `id` of the city where you want to get order. */
  cityId: Scalars['String']['output'];
  /** `name` of the city where you want to get order. */
  cityName: Scalars['String']['output'];
  /** Payment commission */
  commission: Scalars['Float']['output'];
  /** The date of creating order */
  createdAt: Scalars['String']['output'];
  /** Delivery setting for current order */
  deliveryMethod: DeliveryMethod;
  /** Delivery cost */
  deliveryPriceVerbose: Scalars['String']['output'];
  /** Type of delivery. */
  deliveryService: DeliveryService;
  /** Delivery status of the accepted orders, */
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  /** Delivery ttn */
  deliveryTtn?: Maybe<Scalars['String']['output']>;
  /** Order dialog */
  dialog?: Maybe<Dialog>;
  enrollmentCard?: Maybe<EvoCardsInfo>;
  /** The `id` of current order. */
  id: Scalars['Int']['output'];
  /**
   * Is checkout needed for seller
   * @deprecated Seller checkout is always needed
   */
  needSellerCheckout?: Maybe<Scalars['Boolean']['output']>;
  /** 'nextSteps' describe what to do with order on its current stage */
  nextSteps?: Maybe<NextSteps>;
  /** Old commission, which will be shown crossed out */
  oldCommission: Scalars['String']['output'];
  oldDeliveryPrice?: Maybe<Scalars['String']['output']>;
  /** Information of order products */
  orderProducts: Array<OrderProduct>;
  paidAmount?: Maybe<Scalars['String']['output']>;
  payLater?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['String']['output']>;
  /** Payment details of the order */
  paymentDetails: PaymentDetails;
  /** The detailed info about PaymentMethod */
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTransactionStatus?: Maybe<PaymentTransactionStatus>;
  /** Payment type chosen by user when order was created */
  paymentType: PaymentMethodEnum;
  prepayment?: Maybe<Scalars['String']['output']>;
  /** Sum of all products in order. */
  price: Scalars['Float']['output'];
  /**
   * The product that related with current order.
   * @deprecated use orderProducts.product field
   */
  product?: Maybe<Product>;
  /** The id of product that related with current order. */
  productId: Scalars['Int']['output'];
  /** The information about recipient of current order. */
  recipient?: Maybe<OrderRecipient>;
  /** `id` of the region where you want to get order. */
  regionId?: Maybe<Scalars['String']['output']>;
  /** `name` of the region where you want to get order. */
  regionName?: Maybe<Scalars['String']['output']>;
  /**
   * The token which use for create review on seller or buyer. If it's null that
   * user can't leave review for this product.
   * @deprecated User Dialog.reviewsRequest
   */
  reviewToken?: Maybe<Scalars['String']['output']>;
  /** The user who owner of product. */
  seller?: Maybe<User>;
  sellerCommission?: Maybe<Scalars['String']['output']>;
  /** The id of user ho owner of product. */
  sellerId: Scalars['Int']['output'];
  /** Plan id selected on creating the order */
  smartPlanId?: Maybe<Scalars['String']['output']>;
  /** The order status */
  status: OrderStatus;
  /** Created thread `id` */
  threadId: Scalars['Int']['output'];
  /** Total price of the order. Its sum of commission, deliveryPrice, Order.price. */
  totalPrice: Scalars['Float']['output'];
  /** The region where need to send order. */
  warehouseId: Scalars['String']['output'];
  /**
   * `name` of the warehouse where you want to get
   * order.
   */
  warehouseName: Scalars['String']['output'];
  withAcquiring: Scalars['Boolean']['output'];
  withSubscription: Scalars['Boolean']['output'];
};

export type OrderActionsResponse = {
  __typename?: 'OrderActionsResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
  order?: Maybe<Order>;
};

/** The city which should use for create order. */
export type OrderCity = {
  __typename?: 'OrderCity';
  /** The `id` of the current city. */
  id: Scalars['String']['output'];
  /** The `Name` of the current city. */
  name: Scalars['String']['output'];
};

export type OrderCreateResponse = {
  __typename?: 'OrderCreateResponse';
  /** Show that order have been created with success. */
  errors?: Maybe<Array<MutationFieldErrors>>;
  order?: Maybe<Order>;
  userToken?: Maybe<Scalars['String']['output']>;
};

export enum OrderDeclineReason {
  NeedMoreDetails = 'NEED_MORE_DETAILS',
  OrderInfoWasChanged = 'ORDER_INFO_WAS_CHANGED',
  Other = 'OTHER',
  OutOfStock = 'OUT_OF_STOCK',
  TechnicalProblems = 'TECHNICAL_PROBLEMS',
  UnusedDeliveryService = 'UNUSED_DELIVERY_SERVICE'
}

export type OrderDeclineReasonInfo = {
  __typename?: 'OrderDeclineReasonInfo';
  value: OrderDeclineReason;
  verboseInfo: Scalars['String']['output'];
};

export type OrderFilter = {
  paymentStatus?: InputMaybe<PaymentStatusEnum>;
  status?: InputMaybe<OrderStatus>;
  threadId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderPagination = {
  __typename?: 'OrderPagination';
  /** Array of Order. */
  items: Array<Order>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OrderPricesInfo = {
  __typename?: 'OrderPricesInfo';
  activePromoActions: Array<Scalars['String']['output']>;
  additionalCharge?: Maybe<Scalars['String']['output']>;
  appPayAllowed: Scalars['Boolean']['output'];
  commission: Scalars['Float']['output'];
  deliveryPriceVerbose: Scalars['String']['output'];
  hasSubscriptionCondition: Scalars['Boolean']['output'];
  legalText?: Maybe<Scalars['String']['output']>;
  oldCommission: Scalars['String']['output'];
  oldDeliveryPrice?: Maybe<Scalars['String']['output']>;
  orderPrice: Scalars['String']['output'];
  payLater?: Maybe<Scalars['String']['output']>;
  planPrice?: Maybe<Scalars['String']['output']>;
  prepayment?: Maybe<Scalars['String']['output']>;
  sellerCommission?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  amount: Scalars['Int']['output'];
  /** Sum of all products. price = productPrice * amount */
  price: Scalars['String']['output'];
  product: Product;
  /** price for one */
  productPrice: Scalars['String']['output'];
  size?: Maybe<Size>;
};

/**
 * This type represent data which connected with person who will get this order in
 * post.
 */
export type OrderRecipient = {
  __typename?: 'OrderRecipient';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  patronymic: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

/** The region which should use for create order. */
export type OrderRegion = {
  __typename?: 'OrderRegion';
  /** The `id` of the current region. */
  id: Scalars['String']['output'];
  /** The `Name` of the current region. */
  name: Scalars['String']['output'];
};

/** The order has a lot of status. */
export enum OrderStatus {
  /** An order which user decided to archive */
  Archived = 'ARCHIVED',
  /** An order which have been approved by seller and wait for delivery. */
  Confirmed = 'CONFIRMED',
  /** A new order which have not been processed. */
  Created = 'CREATED',
  /** A order which have been declined by buyer or saller. */
  Declined = 'DECLINED',
  /** A order is closed because a product have been sold. */
  Done = 'DONE'
}

export type OrderStatusInfo = {
  __typename?: 'OrderStatusInfo';
  name: Scalars['String']['output'];
  ordersCount: Scalars['Int']['output'];
  value: OrderStatus;
};

/** The warehouse which should use for create order. */
export type OrderWarehouse = {
  __typename?: 'OrderWarehouse';
  /** The `id` of the current warehouse. */
  id: Scalars['String']['output'];
  /** The `Name` of the current warehouse. */
  name: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Information to aid in pagination. */
export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Number of items per page */
  perPage: Scalars['Int']['output'];
  /** Total number of items */
  totalItems: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** Type of the button to show after the purchase */
  button?: Maybe<ButtonEnum>;
  /** Description to show on the screen after purchase */
  description: Scalars['String']['output'];
  /** Icon to show on the screen after purchase */
  icon: Scalars['String']['output'];
  paymentStatus?: Maybe<TransactionPaymentStatusEnum>;
  /** Payment status of the order */
  status: PaymentStatusEnum;
  /** Title to show on the screen after purchase */
  title: Scalars['String']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Color of the description */
  color: Scalars['String']['output'];
  /** Description about current selected payment method */
  description?: Maybe<Scalars['String']['output']>;
  /** icon of the payment method */
  icon: Scalars['String']['output'];
  /** Payment method Enum */
  id: PaymentMethodEnum;
  /** If payment method is hidden */
  isHidden: Scalars['Boolean']['output'];
  /** Human readable name of the payment method */
  name: Scalars['String']['output'];
  /** Short info about selected payment method */
  shortDescription: Scalars['String']['output'];
};

export enum PaymentMethodEnum {
  PayLater = 'PAY_LATER',
  SafePayment = 'SAFE_PAYMENT',
  SellerCard = 'SELLER_CARD'
}

export enum PaymentStatusEnum {
  /** Payment is not applicable to this order */
  NotNeeded = 'NOT_NEEDED',
  /** Buyer haven't paid for the order */
  NotPaid = 'NOT_PAID',
  /** Buyer already paid for this order */
  Paid = 'PAID'
}

export type PaymentTransactionStatus = {
  __typename?: 'PaymentTransactionStatus';
  description?: Maybe<Scalars['String']['output']>;
  status: PaymentTransactionStatusEnum;
  title: Scalars['String']['output'];
};

export enum PaymentTransactionStatusEnum {
  FailedDelivery = 'failed_delivery',
  FailedOrder = 'failed_order',
  Init = 'init',
  Pending = 'pending',
  PendingDelivery = 'pending_delivery',
  PendingOrder = 'pending_order',
  /** wait status of subscription payment */
  PendingSubscription = 'pending_subscription',
  Success = 'success',
  /** Wait status synchronization */
  WaitForSubscription = 'wait_for_subscription'
}

export type PosNegValue = {
  __typename?: 'PosNegValue';
  negative: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type PowInfo = {
  __typename?: 'PowInfo';
  complexity: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
};

/** This type represent information about product. */
export type Product = {
  __typename?: 'Product';
  /** Product's brand */
  brand?: Maybe<Brand>;
  /** Product's brand id */
  brandId?: Maybe<Scalars['Int']['output']>;
  /**
   * Is buyer can leave seller rating
   * @deprecated use Dialog.action
   */
  buyerCanLeaveRating?: Maybe<Scalars['Boolean']['output']>;
  /** List of restrictions if delivery is cargo type */
  cargoRestrictions?: Maybe<Array<Maybe<CargoDeliveryRestriction>>>;
  /** Catalog of the current product */
  catalog?: Maybe<Catalog>;
  /** A count of available Products */
  count: Scalars['Int']['output'];
  /** Reason, why product was declined */
  declineReason?: Maybe<ProductDeclineReason>;
  /** Discount percent is integer between [1, 99] */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  freePushupAvailable: Scalars['Boolean']['output'];
  /** The `id` of current product. */
  id: Scalars['Int']['output'];
  /** Is viewer liked this product */
  isLiked?: Maybe<Scalars['Boolean']['output']>;
  /** Is product condition is new */
  isNew: Scalars['Boolean']['output'];
  /** Return true if current user is owner of product. */
  isOwner: Scalars['Boolean']['output'];
  /** Is seller returns this product */
  isReturnEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user have to confirm duplicate sale */
  isSaleConfirmationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Is product made in ukraine */
  isUkrainian: Scalars['Boolean']['output'];
  /** Likes count */
  likes?: Maybe<Scalars['Int']['output']>;
  /**
   * How much user need money to sell the product
   * @deprecated CPA deleted
   */
  missingCpaCommission: Scalars['Int']['output'];
  /** How much user need money to sell the product */
  missingSaleCommission: Scalars['Int']['output'];
  /** The `name` of current product. */
  name: Scalars['String']['output'];
  nextFreePushupAt?: Maybe<Scalars['Date']['output']>;
  /** Old higher price */
  oldPrice?: Maybe<Scalars['Float']['output']>;
  /** The price of thу current product on UAH. */
  price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingAmount?: Maybe<Scalars['Int']['output']>;
  /** Sale label in context of product */
  saleLabel: SaleLabel;
  /** The user who is owner of this product. */
  seller?: Maybe<User>;
  /** The id of user who is owner of this product. */
  sellerId: Scalars['Int']['output'];
  sellingCondition: SellingConditionEnum;
  /** Available sizes */
  sizes?: Maybe<Array<Size>>;
  /** Available sizes ids */
  sizesIds: Array<Scalars['Int']['output']>;
  /** The visibility status of current product. */
  statusTitle?: Maybe<ProductStatus>;
  /** The list of tags for product */
  tags: Array<TagsEnum>;
  /**
   * Url to main image of current product. This image is small and we can use
   * it for show preview.
   */
  thumbnail: Scalars['String']['output'];
  /** Link to the current product on the website. */
  url: Scalars['String']['output'];
  /** The user status of current product. Show that product is hide or no. */
  userStatusTitle?: Maybe<ProductUserStatus>;
  /** If owner has enabled safe payment method */
  withSafePayment?: Maybe<Scalars['Boolean']['output']>;
};


/** This type represent information about product. */
export type ProductIsSaleConfirmationRequiredArgs = {
  buyerId: Scalars['Int']['input'];
};

export type ProductCharacteristicChoice = {
  __typename?: 'ProductCharacteristicChoice';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Type represents reason, why product was declined */
export type ProductDeclineReason = {
  __typename?: 'ProductDeclineReason';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rules: Array<Rule>;
};

export type ProductReviewForm = {
  __typename?: 'ProductReviewForm';
  expireDate: Scalars['Date']['output'];
  form: Array<ReviewQuestionBlock>;
  product?: Maybe<Product>;
};

/** Possible status for SaleLabel */
export enum ProductSaleStatus {
  SaleNone = 'SALE_NONE',
  SaleNotStarted = 'SALE_NOT_STARTED',
  SaleStarted = 'SALE_STARTED'
}

export enum ProductStatus {
  Available = 'AVAILABLE',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  ModerationRequired = 'MODERATION_REQUIRED',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export enum ProductUserStatus {
  Default = 'DEFAULT',
  Hidden = 'HIDDEN'
}

export type PurchaseResponse = {
  __typename?: 'PurchaseResponse';
  /** URL for 3DS secure confirmation of a payment */
  approveUrl?: Maybe<Scalars['String']['output']>;
  /** List of errors */
  errors?: Maybe<Array<MutationFieldErrors>>;
  payload?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get current user basket */
  basket: Basket;
  dialog?: Maybe<Dialog>;
  evoCardAddForm?: Maybe<Scalars['String']['output']>;
  /** Get widget key for mobile SDK */
  evoPayWidgetKey: Scalars['String']['output'];
  getShipmentStickerLink: ShipmentStickerLink;
  isEvoCardConfirmed?: Maybe<IsCardConfirmedResponse>;
  /** Current Logo */
  logo: LogoImage;
  /** Banner for main screen */
  mainBanner: MainBanner;
  /** Get mini landing object for specified slug */
  miniLanding?: Maybe<MiniLanding>;
  notification?: Maybe<Notification>;
  /** Fetch brands for showing on onboarding screen */
  onBoardingBrands?: Maybe<Array<Brand>>;
  /** Onboarding catalogs */
  onBoardingCatalogs: Scalars['String']['output'];
  /** The information about order. */
  order?: Maybe<Order>;
  /** List of possible delivery cities. */
  orderCities: Array<OrderCity>;
  orderDeclineReasons: Array<OrderDeclineReasonInfo>;
  orderPricesInfo: OrderPricesInfo;
  orderPurchaseForm?: Maybe<Scalars['String']['output']>;
  /** List of possible delivery regions for Justin. */
  orderRegions: Array<OrderRegion>;
  /** List of possible delivery warhouses in the city. */
  orderWarehouses: Array<OrderWarehouse>;
  /** Available payment methods */
  paymentMethods: Array<PaymentMethod>;
  /** Get POW data */
  powInfo: PowInfo;
  /** The information about product with received id. */
  product?: Maybe<Product>;
  /** Get prediction of commission percent (range) for given product price */
  productCommissionPercentPredict: Scalars['String']['output'];
  productsByIds?: Maybe<Array<Product>>;
  /** The information about purchase. */
  purchase?: Maybe<Order>;
  sellerAvailableDeliveryMethods: Array<DeliveryMethod>;
  /** Seo hub for catalog */
  seoHubByCatalog: Array<SeoHubBlock>;
  /** Seo hub for seo_tag */
  seoHubBySeoTag: Array<SeoHubBlock>;
  /** Information about service payment (balance refill, promotion) */
  servicePayment?: Maybe<ServicePayment>;
  settings: GlobalSettings;
  user?: Maybe<User>;
  /** The information about authorized user. */
  viewer?: Maybe<User>;
};


export type QueryDialogArgs = {
  threadId: Scalars['Int']['input'];
};


export type QueryEvoCardAddFormArgs = {
  height?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetShipmentStickerLinkArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryIsEvoCardConfirmedArgs = {
  cardId: Scalars['String']['input'];
};


export type QueryMainBannerArgs = {
  forMobileApps?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMiniLandingArgs = {
  slug: Scalars['String']['input'];
};


export type QueryNotificationArgs = {
  notificationId: Scalars['Int']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderCitiesArgs = {
  cityName?: InputMaybe<Scalars['String']['input']>;
  deliveryService: DeliveryService;
  regionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderDeclineReasonsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryOrderPricesInfoArgs = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  deliveryService: DeliveryService;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  planId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productPrice?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
  warehouseType?: InputMaybe<WarehouseType>;
};


export type QueryOrderPurchaseFormArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderWarehousesArgs = {
  cityId: Scalars['String']['input'];
  deliveryService: DeliveryService;
  purpose?: InputMaybe<WarehousePurpose>;
  type?: InputMaybe<WarehouseType>;
};


export type QueryPaymentMethodsArgs = {
  deliveryService: DeliveryService;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  fromAdv?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  incrViews?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductCommissionPercentPredictArgs = {
  productPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryProductsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPurchaseArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySellerAvailableDeliveryMethodsArgs = {
  sellerId: Scalars['Int']['input'];
};


export type QuerySeoHubByCatalogArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySeoHubBySeoTagArgs = {
  slug: Scalars['String']['input'];
};


export type QueryServicePaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};

export type RatingValue = {
  __typename?: 'RatingValue';
  value: Scalars['String']['output'];
};

export type RemoveSavedSearchResponse = {
  __typename?: 'RemoveSavedSearchResponse';
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

export enum ReturnPolicy {
  /** New products */
  NewOnly = 'NEW_ONLY',
  /** Not new products */
  UsedOnly = 'USED_ONLY'
}

export type ReturnPolicySetting = {
  __typename?: 'ReturnPolicySetting';
  /** Return policy description */
  description: Scalars['String']['output'];
  /** Is seller can change value of `isEnabled` for this policy */
  isEditable: Scalars['Boolean']['output'];
  /** Is seller return products with this `returnPolicy` */
  isEnabled: Scalars['Boolean']['output'];
  /** Return policy name */
  name: Scalars['String']['output'];
  /** Unique identifier of return policy setting */
  returnPolicy: ReturnPolicy;
};

/** This type represents information about product Review */
export type Review = {
  __typename?: 'Review';
  /** Review category type (from buyer or seller) */
  category: ReviewCategory;
  /** Date review was created */
  createdAt: Scalars['String']['output'];
  /** Id of review */
  id: Scalars['Int']['output'];
  /** Author of review */
  owner: User;
  /** Id of review author */
  ownerId: Scalars['Int']['output'];
  /** Product, for which review was written */
  product?: Maybe<Product>;
  /** Id of product, for which review was written */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Review rating type */
  rating: ReviewRating;
  /** Content of review */
  text?: Maybe<Scalars['String']['output']>;
};

export enum ReviewCategory {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type ReviewQuestion = {
  __typename?: 'ReviewQuestion';
  /** String identifier of question */
  id: Scalars['String']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Selected earlier answer, if exists */
  selectedValue?: Maybe<Scalars['String']['output']>;
  /** Question title */
  title: Scalars['String']['output'];
  /** Question type */
  type: SellerRatingQuestionType;
  valueChoices: Array<ReviewQuestionValue>;
};

export type ReviewQuestionBlock = {
  __typename?: 'ReviewQuestionBlock';
  questions: Array<ReviewQuestion>;
};

export type ReviewQuestionValue = {
  __typename?: 'ReviewQuestionValue';
  /** Id of answer value */
  id: Scalars['String']['output'];
  /** Human-readable answer value */
  text: Scalars['String']['output'];
};

export enum ReviewRating {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type ReviewRequest = {
  __typename?: 'ReviewRequest';
  dialog?: Maybe<Dialog>;
  hasCounterReview: Scalars['Boolean']['output'];
  hasSell: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  productReviewForms?: Maybe<Array<ProductReviewForm>>;
  threadId: Scalars['Int']['output'];
  userReviewForm?: Maybe<UserReviewForm>;
  userRole: UserRole;
  userTo?: Maybe<User>;
};

export type ReviewRequestConnection = {
  __typename?: 'ReviewRequestConnection';
  edges: Array<Maybe<ReviewRequestEdge>>;
  pageInfo: PageInfo;
};

export type ReviewRequestEdge = {
  __typename?: 'ReviewRequestEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReviewRequest>;
};

/** Type represents rule, why product was declined */
export type Rule = {
  __typename?: 'Rule';
  canBeFixed: Scalars['Boolean']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Sale in context of product */
export type SaleLabel = {
  __typename?: 'SaleLabel';
  date: Scalars['Date']['output'];
  price: Scalars['Float']['output'];
  status: ProductSaleStatus;
};

export type SaveDeviceInfo = {
  __typename?: 'SaveDeviceInfo';
  isSuccess: Scalars['Boolean']['output'];
};

export type SaveSearchResponse = {
  __typename?: 'SaveSearchResponse';
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
  savedSearchId?: Maybe<Scalars['Int']['output']>;
};

export type SellerRatingAnswer = {
  /** If of question, that is answered */
  questionId: Scalars['String']['input'];
  /** Id of Question Value */
  selectedValueId: Scalars['String']['input'];
};

export type SellerRatingInfo = {
  __typename?: 'SellerRatingInfo';
  blocks: Array<SellerRatingInfoBlock>;
  overallRating: Scalars['String']['output'];
  reviewsCount: Scalars['Int']['output'];
  reviewsCountByPeriod: Scalars['Int']['output'];
};

export type SellerRatingInfoBlock = {
  __typename?: 'SellerRatingInfoBlock';
  items: Array<SellerRatingItem>;
};

export type SellerRatingItem = {
  __typename?: 'SellerRatingItem';
  title: Scalars['String']['output'];
  value?: Maybe<SellerRatingValue>;
};

export type SellerRatingPoll = {
  __typename?: 'SellerRatingPoll';
  /** Order, for which rating is filled */
  id: Scalars['Int']['output'];
  /** Questions, splitted in blocks */
  questionBlocks: Array<SellerRatingQuestionBlock>;
};

export type SellerRatingPollInput = {
  /** List of answered questions, that answered */
  answers: Array<SellerRatingAnswer>;
  /** Poll id, that is filled */
  pollId: Scalars['Int']['input'];
};

export type SellerRatingPollResult = {
  __typename?: 'SellerRatingPollResult';
  /** Save rating poll result */
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type SellerRatingQuestion = {
  __typename?: 'SellerRatingQuestion';
  id: Scalars['String']['output'];
  /** Previously answered value, if exists */
  selectedValue?: Maybe<SellerRatingQuestionValue>;
  /** Title of question */
  title: Scalars['String']['output'];
  /** Question type */
  type: SellerRatingQuestionType;
  /** Answer values choises */
  valueChoices?: Maybe<Array<SellerRatingQuestionValue>>;
};

export type SellerRatingQuestionBlock = {
  __typename?: 'SellerRatingQuestionBlock';
  /** Block is needed for visual splitting of questions in form */
  questions?: Maybe<Array<SellerRatingQuestion>>;
};

export enum SellerRatingQuestionType {
  /** Values: RATING_1_STAR, ..., RATING_5_STAR */
  TypeOverallRating = 'TYPE_OVERALL_RATING',
  TypePhotos = 'TYPE_PHOTOS',
  /** Values: RATING_1_STAR, ..., RATING_5_STAR */
  TypeRating = 'TYPE_RATING',
  TypeTextArea = 'TYPE_TEXT_AREA',
  /** One of text choises */
  TypeTextChoice = 'TYPE_TEXT_CHOICE',
  /** Values: THUMB_UP; THUMB_DOWN */
  TypeThumbUpDown = 'TYPE_THUMB_UP_DOWN'
}

export type SellerRatingQuestionValue = {
  __typename?: 'SellerRatingQuestionValue';
  /** Id of answer value, need to submit answer */
  id: Scalars['String']['output'];
  /** Human-readable answer value */
  text: Scalars['String']['output'];
};

export type SellerRatingResult = {
  __typename?: 'SellerRatingResult';
  blocks?: Maybe<Array<SellerRatingResultBlock>>;
};

export type SellerRatingResultBlock = {
  __typename?: 'SellerRatingResultBlock';
  items?: Maybe<Array<SellerRatingResultItem>>;
};

export type SellerRatingResultItem = {
  __typename?: 'SellerRatingResultItem';
  title: Scalars['String']['output'];
  type?: Maybe<SellerRatingResultType>;
  value: SellerRatingResultValue;
};

export enum SellerRatingResultType {
  /** Average rating */
  TypeRating = 'TYPE_RATING',
  /** Average rating with reviews count */
  TypeRatingWithReviewsCount = 'TYPE_RATING_WITH_REVIEWS_COUNT',
  /** Text with image aggreagtion of some answer\seller info */
  TypeTextWithImage = 'TYPE_TEXT_WITH_IMAGE',
  /** Count for thumbs up\down */
  TypeThumbsUpDownCount = 'TYPE_THUMBS_UP_DOWN_COUNT'
}

export type SellerRatingResultValue = {
  __typename?: 'SellerRatingResultValue';
  /**
   * Values for:
   * TYPE_RATING_WITH_REVIEWS_COUNT, TYPE_RATING\
   */
  averageRating?: Maybe<Scalars['Float']['output']>;
  imageLink?: Maybe<Scalars['String']['output']>;
  /**
   * Values for:
   * TYPE_RATING_WITH_REVIEWS_COUNT
   */
  ratingsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Values for:
   * TYPE_TEXT_WITH_IMAGE
   */
  text?: Maybe<Scalars['String']['output']>;
  thumbDownCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Values for:
   * TYPE_THUMBS_UP_DOWN_COUNT
   */
  thumbUpCount?: Maybe<Scalars['Int']['output']>;
};

export type SellerRatingValue = PosNegValue | RatingValue | TextValue;

export enum SellingConditionEnum {
  Exchange = 'EXCHANGE',
  ForSaleAndExchange = 'FOR_SALE_AND_EXCHANGE',
  Gift = 'GIFT',
  Sale = 'SALE'
}

export type SendExternalCardsVerificationOtpResponse = {
  __typename?: 'SendExternalCardsVerificationOTPResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SeoHubBlock = {
  __typename?: 'SeoHubBlock';
  blockType: SeoHubBlockType;
  items: Array<SeoHubBlockItem>;
  title: Scalars['String']['output'];
};

export type SeoHubBlockItem = {
  __typename?: 'SeoHubBlockItem';
  pictureUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum SeoHubBlockType {
  Brands = 'BRANDS',
  FirstCustomBlock = 'FIRST_CUSTOM_BLOCK',
  PopularCategories = 'POPULAR_CATEGORIES',
  SecondCustomBlock = 'SECOND_CUSTOM_BLOCK'
}

export type ServicePayment = {
  __typename?: 'ServicePayment';
  meta?: Maybe<ServicePaymentMeta>;
  paymentDetails?: Maybe<PaymentDetails>;
  scope: ServicePaymentScope;
};

export type ServicePaymentMeta = {
  __typename?: 'ServicePaymentMeta';
  amount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use subscriptionPlanId */
  planId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  promoPackageId?: Maybe<Scalars['Int']['output']>;
  subscriptionPlanId?: Maybe<Scalars['String']['output']>;
  tariffId?: Maybe<Scalars['Int']['output']>;
};

export type ServicePaymentResponse = {
  __typename?: 'ServicePaymentResponse';
  data?: Maybe<ServicePaymentResult>;
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type ServicePaymentResult = {
  __typename?: 'ServicePaymentResult';
  /** 3DS link */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<PaymentDetails>;
  paymentId: Scalars['Int']['output'];
};

export enum ServicePaymentScope {
  ScopeBalanceRefill = 'SCOPE_BALANCE_REFILL',
  ScopePromotion = 'SCOPE_PROMOTION',
  ScopePromoPackage = 'SCOPE_PROMO_PACKAGE',
  ScopeSubscription = 'SCOPE_SUBSCRIPTION'
}

export type SetSavedSearchNewProductsNotifyResponse = {
  __typename?: 'SetSavedSearchNewProductsNotifyResponse';
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

export type ShipmentStickerLink = {
  __typename?: 'ShipmentStickerLink';
  link: Scalars['String']['output'];
};

/** Type represents products sizes */
export type Size = {
  __typename?: 'Size';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primarySizeName: Scalars['String']['output'];
  secondarySizeName?: Maybe<Scalars['String']['output']>;
};

export type SlideImage = {
  __typename?: 'SlideImage';
  /** Url to slide image suited for mobile devices */
  mobile: Scalars['String']['output'];
  /** Url to slide image for tablet or desktop screen sizes */
  tablet: Scalars['String']['output'];
};

export type SubscribeToBrandResponse = {
  __typename?: 'SubscribeToBrandResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type SubscribeToBrandsResponse = {
  __typename?: 'SubscribeToBrandsResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type SubscribeToProductResponse = {
  __typename?: 'SubscribeToProductResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

/**
 * Enum with tags
 * - UKRBRAND - made in UK tag
 * - FREE_SHIPPING - Promo action tag - free shipping
 * - ADULT_ONLY - adult only
 * - FROM_ROZETKA - product from Rozetka
 */
export enum TagsEnum {
  AdultOnly = 'ADULT_ONLY',
  FreeShipping = 'FREE_SHIPPING',
  FromRozetka = 'FROM_ROZETKA',
  PromoteForGoogle = 'PROMOTE_FOR_GOOGLE',
  SmartAvailable = 'SMART_AVAILABLE',
  Ukrbrand = 'UKRBRAND'
}

export type TextValue = {
  __typename?: 'TextValue';
  img: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum TransactionPaymentStatusEnum {
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success'
}

export type UnsubscribeFromBrandResponse = {
  __typename?: 'UnsubscribeFromBrandResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UpdateBasketProductCountResponse = {
  __typename?: 'UpdateBasketProductCountResponse';
  basket: Basket;
  basketProduct?: Maybe<BasketProduct>;
  errors?: Maybe<Array<Maybe<MutationFieldErrors>>>;
};

export type UpdatePaymentMethodsResponse = {
  __typename?: 'UpdatePaymentMethodsResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
  paymentMethod?: Maybe<UserPaymentInfo>;
};

/** This type represent information about user. */
export type User = {
  __typename?: 'User';
  /** Availabe user accounts */
  availableAccounts?: Maybe<Array<UserAccountInfo>>;
  /** An url of user's avatar. */
  avatar: Scalars['String']['output'];
  /** Ban info (null if there is no ban) */
  ban?: Maybe<UserBanInfo>;
  /** Describe user block status and who blocked him */
  blockedBy?: Maybe<UserBlockedByEnum>;
  city?: Maybe<City>;
  /** Return the settings for user delivery */
  deliverySettings: Array<UserDeliverySettings>;
  deltaDateJoined?: Maybe<Scalars['String']['output']>;
  /** The `email` of current user on web site. */
  email?: Maybe<Scalars['String']['output']>;
  enrollmentCard?: Maybe<Scalars['String']['output']>;
  /** List of user cards (viewer only) */
  evoCards?: Maybe<Array<EvoCardsInfo>>;
  externalPaymentCardsInfo?: Maybe<Array<ExternalPaymentCardsInfo>>;
  /** The first name of current user. */
  firstName?: Maybe<Scalars['String']['output']>;
  followersCount: Scalars['Int']['output'];
  freePushupsLeft: Scalars['Int']['output'];
  freePushupsLimit: Scalars['Int']['output'];
  /** Free shipping information */
  freeShippingInfo?: Maybe<FreeShippingInfoType>;
  hasRecentActivity: Scalars['Boolean']['output'];
  /** If need hide payment settings for user */
  hidePaymentSettings?: Maybe<Scalars['Boolean']['output']>;
  /** The `id` of current user. */
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  /** is bank id verification is mandatory for user */
  isBankIdVerificationMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** is user verified by bank id */
  isBankIdVerified?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is mobile app installed, at least once for, viewer.
   * Note: if user delete mobile app after install, this field still return true.
   */
  isMobileAppInstalled?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user is new */
  isNewSeller?: Maybe<Scalars['Boolean']['output']>;
  isPrivateSeller: Scalars['Boolean']['output'];
  isSeller: Scalars['Boolean']['output'];
  /** Return `true` if logged user are subscribed to the current user. */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user is top seller */
  isTopSeller?: Maybe<Scalars['Boolean']['output']>;
  /** is user is restricted by bank id verification */
  isUserRestrictedByBankId?: Maybe<Scalars['Boolean']['output']>;
  isWorking: Scalars['Boolean']['output'];
  /** Information about last deliveries of User for each `deliveryService` */
  lastDeliveries?: Maybe<Array<UserDeliveryInfo>>;
  /** The last name of current user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Last time visit */
  lastVisit?: Maybe<Scalars['Int']['output']>;
  /** Middle time of response */
  middleResponseTime?: Maybe<Scalars['String']['output']>;
  /** Return count of negative reviews for current user. */
  negativeReviews?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<Array<NotificationSetting>>;
  notifications?: Maybe<NotificationConnection>;
  /** Percent of done orders */
  orderRate?: Maybe<Scalars['String']['output']>;
  /** List of `orders` for curent user. */
  orders?: Maybe<OrderPagination>;
  /** The patronymic name of current user. (the name of father). */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Information about user payment methods */
  paymentMethods?: Maybe<Array<UserPaymentInfo>>;
  /** The `phone number` of current user. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Return count of positive reviews for current user. */
  positiveReviews?: Maybe<Scalars['String']['output']>;
  prepayment?: Maybe<Scalars['String']['output']>;
  /** Information about user's purchase order statuses */
  purchaseStatuses?: Maybe<Array<OrderStatusInfo>>;
  /** List of `purchases` for current user. */
  purchases?: Maybe<OrderPagination>;
  /** true if user should update his delivery settings */
  requestDeliverySettingsUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** true if user should update his payment settings */
  requestPaymentSettingsUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Information about user return policy settings */
  returnPolicies?: Maybe<Array<ReturnPolicySetting>>;
  reviewRequests?: Maybe<ReviewRequestConnection>;
  /** Information about user's sale order statuses */
  saleStatuses?: Maybe<Array<OrderStatusInfo>>;
  /**
   * Average rating of seller
   * @deprecated Use sellerRatingInfo
   */
  sellerRating?: Maybe<Scalars['Float']['output']>;
  sellerRatingInfo?: Maybe<SellerRatingInfo>;
  /** Name of user's shop */
  shopName?: Maybe<Scalars['String']['output']>;
  /** Brands on which viewer subscribed */
  subscribedBrands?: Maybe<Array<Brand>>;
  /** Prerequisites that should be completed to add products */
  uncompletedAddProductPrerequisites?: Maybe<Array<AddProductPrerequisite>>;
  /** The `name` of current user on web site. */
  username: Scalars['String']['output'];
};


/** This type represent information about user. */
export type UserDeliverySettingsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This type represent information about user. */
export type UserHidePaymentSettingsArgs = {
  deliveryService?: InputMaybe<Scalars['String']['input']>;
};


/** This type represent information about user. */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represent information about user. */
export type UserOrdersArgs = {
  filters?: InputMaybe<OrderFilter>;
  pagination: PaginationInput;
};


/** This type represent information about user. */
export type UserPaymentMethodsArgs = {
  deliveryService?: InputMaybe<Scalars['String']['input']>;
};


/** This type represent information about user. */
export type UserPurchasesArgs = {
  filters?: InputMaybe<OrderFilter>;
  pagination: PaginationInput;
};


/** This type represent information about user. */
export type UserReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  /** Description of the account */
  description: Scalars['String']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
  /** Account type */
  type: UserAccountType;
};

export type UserAccountInfo = {
  __typename?: 'UserAccountInfo';
  /** Main account info */
  account: UserAccount;
  /** Flag, if user can switch to this type of account */
  enabledSwitchTo: Scalars['Boolean']['output'];
  /** Is this account currently working for user */
  isActive: Scalars['Boolean']['output'];
  /** Flag that represents, if user can use kayako messenger */
  isKayakoEnabled: Scalars['Boolean']['output'];
  /** Reason, why this account cannot be turned on for user */
  reasonSwitchDisabled?: Maybe<Scalars['String']['output']>;
};

export enum UserAccountType {
  /** Business user account */
  AccountTypeBusiness = 'ACCOUNT_TYPE_BUSINESS',
  /** Simple user account */
  AccountTypeSimple = 'ACCOUNT_TYPE_SIMPLE'
}

export type UserBanInfo = {
  __typename?: 'UserBanInfo';
  /** Reason of ban */
  reason: Scalars['String']['output'];
  /** Reason type */
  reasonType: UserBanReasonTypeEnum;
  /** Date, when ban was created */
  validFrom: Scalars['String']['output'];
  /** Date of ban expiration (null if there is no end for ban) */
  validUntil?: Maybe<Scalars['String']['output']>;
};

export enum UserBanReasonTypeEnum {
  TypeFraud = 'TYPE_FRAUD',
  TypeOther = 'TYPE_OTHER'
}

export enum UserBlockedByEnum {
  BlockedByAdmin = 'BLOCKED_BY_ADMIN',
  BlockedBySystem = 'BLOCKED_BY_SYSTEM',
  NotBlocked = 'NOT_BLOCKED'
}

export type UserDeliveryInfo = {
  __typename?: 'UserDeliveryInfo';
  /** Delivery city info */
  city: OrderCity;
  defaultPrice?: Maybe<Scalars['Int']['output']>;
  /** Delivery service enum */
  deliveryService: DeliveryService;
  /** Delivery description */
  description: Scalars['String']['output'];
  /** Icon for the delivery service */
  icon: Scalars['String']['output'];
  /** Human readeble representation of delivery service */
  name: Scalars['String']['output'];
  /** Delivery region info */
  region?: Maybe<OrderRegion>;
  smartDescription?: Maybe<Scalars['String']['output']>;
  smartPostomateDescription?: Maybe<Scalars['String']['output']>;
  /** Delivery warehouse info */
  warehouse: OrderWarehouse;
};

export type UserDeliverySettings = {
  __typename?: 'UserDeliverySettings';
  city?: Maybe<OrderCity>;
  deliveryService: DeliveryService;
  description: Scalars['String']['output'];
  hiddenDescription?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  minTariff: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<OrderRegion>;
  /** Description of delivery in smart subscription */
  smartDescription?: Maybe<Scalars['String']['output']>;
  /** Description of postomate delivery in smart subscription */
  smartPostomateDescription?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<DeliverySettingsWarehouse>;
};

export type UserPaymentInfo = {
  __typename?: 'UserPaymentInfo';
  description: Scalars['String']['output'];
  descriptionIfHidden: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: PaymentMethodEnum;
  isEnabled: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type UserReviewForm = {
  __typename?: 'UserReviewForm';
  expireDate: Scalars['Date']['output'];
  form: Array<ReviewQuestionBlock>;
  user?: Maybe<User>;
};

export enum UserRole {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type UtmLabels = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyExternalCardsOtpResponse = {
  __typename?: 'VerifyExternalCardsOTPResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export enum WarehousePurpose {
  Receiving = 'RECEIVING',
  Sending = 'SENDING'
}

export enum WarehouseType {
  Postomate = 'POSTOMATE',
  PostOffice = 'POST_OFFICE'
}

export type DeliverySettingUpdateResponse = {
  __typename?: 'deliverySettingUpdateResponse';
  /** Delivery Setting that was updated */
  deliverySetting?: Maybe<UserDeliverySettings>;
  /** Message send to product errors. */
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type IsCardConfirmedResponse = {
  __typename?: 'isCardConfirmedResponse';
  card?: Maybe<EvoCardsInfo>;
  confirmationStatus: CardConfirmationStatus;
};

export type MessageSendToProductDialogResponse = {
  __typename?: 'messageSendToProductDialogResponse';
  /** Message send to product errors. */
  errors?: Maybe<Array<MutationFieldErrors>>;
  /** Dialog thread id */
  threadId?: Maybe<Scalars['Int']['output']>;
};

export type UserAddEvoCardLookupResponse = {
  __typename?: 'userAddEvoCardLookupResponse';
  cardId?: Maybe<Scalars['String']['output']>;
  /** Confirmation url to 3DS */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UserAssociateWithSocialAccountResponse = {
  __typename?: 'userAssociateWithSocialAccountResponse';
  /** User association errors */
  errors?: Maybe<Array<MutationFieldErrors>>;
  /** Updated user */
  user?: Maybe<User>;
};

export type UserFastRegistrationResponse = {
  __typename?: 'userFastRegistrationResponse';
  /** user auth token */
  authToken?: Maybe<Scalars['String']['output']>;
  /** User fast registration errors */
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UserMarkDefaultEvoCardResponse = {
  __typename?: 'userMarkDefaultEvoCardResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UserRemoveEvoCardResponse = {
  __typename?: 'userRemoveEvoCardResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UserUpdateEmailResponse = {
  __typename?: 'userUpdateEmailResponse';
  errors?: Maybe<Array<MutationFieldErrors>>;
};

export type UserUpdateReturnPolicySetting = {
  __typename?: 'userUpdateReturnPolicySetting';
  /** Settings update errors */
  errors?: Maybe<Array<MutationFieldErrors>>;
  /** Updated return policy setting */
  returnPolicySetting?: Maybe<ReturnPolicySetting>;
};

export type UserUpdateShopNameResponse = {
  __typename?: 'userUpdateShopNameResponse';
  user?: Maybe<User>;
};

export type ErrorsDataFragment = { __typename?: 'MutationFieldErrors', field: string, messages: Array<{ __typename?: 'MutationError', code: string, message: string }> } & { ' $fragmentName'?: 'ErrorsDataFragment' };

export type ProductLikesFragment = { __typename?: 'Product', likes?: number | null, isLiked?: boolean | null } & { ' $fragmentName'?: 'ProductLikesFragment' };

export type OrderContactsInfoFragment = { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, patronymic?: string | null, phone?: string | null, email?: string | null } & { ' $fragmentName'?: 'OrderContactsInfoFragment' };

export type LastDeliveryInfoFragment = { __typename?: 'User', lastDeliveries?: Array<{ __typename?: 'UserDeliveryInfo', deliveryService: DeliveryService, name: string, description: string, smartDescription?: string | null, smartPostomateDescription?: string | null, defaultPrice?: number | null, icon: string, city: { __typename?: 'OrderCity', id: string, name: string }, region?: { __typename?: 'OrderRegion', id: string, name: string } | null, warehouse: { __typename?: 'OrderWarehouse', id: string, name: string } }> | null } & { ' $fragmentName'?: 'LastDeliveryInfoFragment' };

export type SellerDeliveryInfoFragment = { __typename?: 'User', deliverySettings: Array<{ __typename?: 'UserDeliverySettings', name: string, description: string, deliveryService: DeliveryService, icon: string, smartDescription?: string | null, smartPostomateDescription?: string | null }> } & { ' $fragmentName'?: 'SellerDeliveryInfoFragment' };

export type SaleCardInfoFragment = { __typename?: 'Order', id: number, price: number, buyerId: number, threadId: number, reviewToken?: string | null, status: OrderStatus, createdAt: string, needSellerCheckout?: boolean | null, withSubscription: boolean, canBeDelete: boolean, canBeDecline: boolean, canBeApprove: boolean, canBeMarkAsSold: boolean, canBePaid?: boolean | null, product?: { __typename?: 'Product', id: number, name: string, thumbnail: string, url: string } | null, deliveryMethod: { __typename?: 'DeliveryMethod', deliveryService: DeliveryService, icon: string, name: string }, buyer?: { __typename?: 'User', id: number, username: string } | null, paymentDetails: { __typename?: 'PaymentDetails', status: PaymentStatusEnum } } & { ' $fragmentName'?: 'SaleCardInfoFragment' };

export type OrderActionsOpportunitiesFragment = { __typename?: 'Order', canBeDelete: boolean, canBeDecline: boolean, canBeApprove: boolean, canBeMarkAsSold: boolean, canBePaid?: boolean | null, reviewToken?: string | null, product?: { __typename?: 'Product', id: number } | null } & { ' $fragmentName'?: 'OrderActionsOpportunitiesFragment' };

export type PurchaseCardInfoFragment = { __typename?: 'Order', id: number, price: number, threadId: number, reviewToken?: string | null, status: OrderStatus, createdAt: string, withSubscription: boolean, withAcquiring: boolean, canBeDelete: boolean, canBeDecline: boolean, canBeApprove: boolean, canBeMarkAsSold: boolean, canBePaid?: boolean | null, product?: { __typename?: 'Product', id: number, name: string, thumbnail: string, url: string } | null, deliveryMethod: { __typename?: 'DeliveryMethod', deliveryService: DeliveryService, icon: string, name: string }, seller?: { __typename?: 'User', id: number, username: string } | null, paymentDetails: { __typename?: 'PaymentDetails', status: PaymentStatusEnum } } & { ' $fragmentName'?: 'PurchaseCardInfoFragment' };

export type PurchaseSellerInfoFragment = { __typename?: 'User', id: number, username: string, shopName?: string | null, avatar: string, isSubscribed?: boolean | null, lastVisit?: number | null, middleResponseTime?: string | null, orderRate?: string | null, isTopSeller?: boolean | null, sellerRatingInfo?: { __typename?: 'SellerRatingInfo', overallRating: string, reviewsCount: number } | null } & { ' $fragmentName'?: 'PurchaseSellerInfoFragment' };

export type OrderStatusFragment = { __typename?: 'Order', id: number, status: OrderStatus } & { ' $fragmentName'?: 'OrderStatusFragment' };

export type PaymentCardInfoFragment = { __typename?: 'EvoCardsInfo', id?: string | null, cardHolderId: string, cardMask: string, type?: string | null, isDefault: boolean, bankImage?: string | null, expiresAt?: string | null, isExpired: boolean, isExternal: boolean } & { ' $fragmentName'?: 'PaymentCardInfoFragment' };

export type ProductCardFeedDataFragment = { __typename?: 'Product', id: number, url: string, thumbnail: string, name: string, price?: number | null, oldPrice?: number | null, statusTitle?: ProductStatus | null, discountPercent?: number | null, isNew: boolean, isUkrainian: boolean, tags: Array<TagsEnum>, rating?: number | null, ratingAmount?: number | null, sellingCondition: SellingConditionEnum, likes?: number | null, isLiked?: boolean | null, brand?: { __typename?: 'Brand', id: number, name: string } | null, catalog?: { __typename?: 'Catalog', id: number, slug: string } | null, saleLabel: { __typename?: 'SaleLabel', status: ProductSaleStatus, date: any, price: number }, size?: Array<{ __typename?: 'Size', id: number, name: string }> | null, seller?: { __typename?: 'User', hasRecentActivity: boolean, id: number, isTopSeller?: boolean | null } | null } & { ' $fragmentName'?: 'ProductCardFeedDataFragment' };

export type SeoHubDataFragment = { __typename?: 'SeoHubBlock', title: string, blockType: SeoHubBlockType, items: Array<{ __typename?: 'SeoHubBlockItem', title: string, url: string, pictureUrl?: string | null }> } & { ' $fragmentName'?: 'SeoHubDataFragment' };

export const ErrorsDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"errorsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationFieldErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;
export const OrderContactsInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderContactsInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"patronymic"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode;
export const LastDeliveryInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"lastDeliveryInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastDeliveries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryService"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"smartDescription"}},{"kind":"Field","name":{"kind":"Name","value":"smartPostomateDescription"}},{"kind":"Field","name":{"kind":"Name","value":"defaultPrice"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;
export const SellerDeliveryInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sellerDeliveryInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliverySettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enabledOnly"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryService"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"smartDescription"}},{"kind":"Field","name":{"kind":"Name","value":"smartPostomateDescription"}}]}}]}}]} as unknown as DocumentNode;
export const OrderActionsOpportunitiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderActionsOpportunities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canBeDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canBeDecline"}},{"kind":"Field","name":{"kind":"Name","value":"canBeApprove"}},{"kind":"Field","name":{"kind":"Name","value":"canBeMarkAsSold"}},{"kind":"Field","name":{"kind":"Name","value":"canBePaid"}},{"kind":"Field","name":{"kind":"Name","value":"reviewToken"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export const SaleCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"saleCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderActionsOpportunities"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryService"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyerId"}},{"kind":"Field","name":{"kind":"Name","value":"threadId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewToken"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"needSellerCheckout"}},{"kind":"Field","name":{"kind":"Name","value":"withSubscription"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderActionsOpportunities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canBeDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canBeDecline"}},{"kind":"Field","name":{"kind":"Name","value":"canBeApprove"}},{"kind":"Field","name":{"kind":"Name","value":"canBeMarkAsSold"}},{"kind":"Field","name":{"kind":"Name","value":"canBePaid"}},{"kind":"Field","name":{"kind":"Name","value":"reviewToken"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export const PurchaseCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"purchaseCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderActionsOpportunities"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryService"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"threadId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewToken"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"withSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"withAcquiring"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderActionsOpportunities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canBeDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canBeDecline"}},{"kind":"Field","name":{"kind":"Name","value":"canBeApprove"}},{"kind":"Field","name":{"kind":"Name","value":"canBeMarkAsSold"}},{"kind":"Field","name":{"kind":"Name","value":"canBePaid"}},{"kind":"Field","name":{"kind":"Name","value":"reviewToken"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export const PurchaseSellerInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"purchaseSellerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribed"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisit"}},{"kind":"Field","name":{"kind":"Name","value":"middleResponseTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderRate"}},{"kind":"Field","name":{"kind":"Name","value":"sellerRatingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overallRating"}},{"kind":"Field","name":{"kind":"Name","value":"reviewsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTopSeller"}}]}}]} as unknown as DocumentNode;
export const OrderStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode;
export const PaymentCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EvoCardsInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardHolderId"}},{"kind":"Field","name":{"kind":"Name","value":"cardMask"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"bankImage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"isExternal"}}]}}]} as unknown as DocumentNode;
export const ProductLikesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const ProductCardFeedDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productCardFeedData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"oldPrice"}},{"kind":"Field","name":{"kind":"Name","value":"statusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"productLikes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"saleLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUkrainian"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasRecentActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isTopSeller"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellingCondition"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const SeoHubDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"seoHubData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SeoHubBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"blockType"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}}]} as unknown as DocumentNode;